import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  // Auth
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/LoginView.vue'),
  },
  // Recordings
  {
    path: '/audioRecording',
    name: 'audioRecording',
    component: () => import('../views/recordings/AudioRecording.vue'),
  },
  {
    path: '/audioRecordings',
    name: 'audioRecordings',
    component: () => import('../views/recordings/AudioRecordings.vue'),
  },
  {
    path: '/screenRecording',
    name: 'screenRecording',
    component: () => import('../views/recordings/ScreenRecordingView.vue'),
  },
  {
    path: '/screenRecordings',
    name: 'screenRecordings',
    component: () => import('../views/recordings/ScreenRecordings.vue'),
  },
  // Transcriptions
  {
    path: '/myUploads',
    name: 'myUploads',
    component: () => import('../views/transcriptions/MyUploadsView.vue'),
  },
  {
    path: '/myTranslations',
    name: 'myTranslations',
    component: () => import('../views/transcriptions/MyTranslationsView.vue'),
  },
  {
    path: '/groupTranscriptions',
    name: 'groupTranscriptions',
    component: () => import('../views/transcriptions/GroupTranscriptionsView.vue'),
  },
  {
    path: '/folderTranscriptions/:id/:name',
    name: 'folderTranscriptions',
    component: () => import('../views/transcriptions/FolderTranscriptions.vue'),
  },
  {
    path: '/oneTranscription/:id/:name',
    name: 'oneTranscription',
    component: () => import('../views/transcriptions/GetOneTranscription.vue'),
  },
  {
    path: '/share/:id/:name',
    name: 'shareTranscription',
    component: () => import('../views/transcriptions/PublicTranscription.vue'),
    meta: { public: true },
  },
  // Articles / Content
  {
    path: '/articles',
    name: 'articles',
    component: () => import('../views/articles/ArticlesView.vue'),
  },
  {
    path: '/article/:id/:title',
    name: 'oneArticle',
    component: () => import('../views/articles/GetOneArticle.vue'),
  },
  {
    path: '/myContents',
    name: 'myContents',
    component: () => import('../views/articles/MyContentsView.vue'),
  },
  {
    path: '/createContent',
    name: 'createContent',
    component: () => import('../views/articles/CreateContent.vue'),
  },
  // Services
  {
    path: '/subtitles',
    name: 'subtitles',
    component: () => import('../views/services/Subtitles.vue'),
  },
  {
    path: '/textToSpeech',
    name: 'textToSpeech',
    component: () => import('../views/services/TextToSpeech.vue'),
  },
  {
    path: '/translateText',
    name: 'translateText',
    component: () => import('../views/services/TranslateText.vue'),
  },
  // Admin
  {
    path: '/adminPanel',
    name: 'adminPanel',
    component: () => import('../views/admin/AdminPanel.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const store = require('../store').default;
  const isRecording = store.state.recorder.isRecording;
  const isMinimized = store.state.recorder.minimized;

  if (isRecording && from.name === 'screenRecording' && to.name !== 'screenRecording' && !isMinimized) {
    store.dispatch('recorder/minimizeRecorder');
  }

  next();
});

export default router
